module.exports = __webpack_public_path__ + "static/img/26.ad76592.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/ProcessAutomation/26.png
// module id = /xR/
// module chunks = 1